import { useEffect } from 'react';
import { parseAuthMessage } from '../utils/helpers/authMessage';

interface UseAuthPostMessageProps {
  onSuccess: (accessToken: string) => void;
  onClose: () => void;
}

export const useAuthPostMessage = ({
  onSuccess,
  onClose
}: UseAuthPostMessageProps) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent<unknown>) => {
      const message = parseAuthMessage(event);

      if (message?.type === 'finished') {
        onSuccess(message.accessToken);
      } else if (message?.type === 'closed') {
        onClose();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onSuccess, onClose]);
};
